const localStorage = window.localStorage;

const STORAGE_PREFIX = 'livemonitor.';

const save = (key: string, value: string | boolean | object, prefix = STORAGE_PREFIX) => {
    try {
        localStorage.setItem(`${prefix}${key}`, JSON.stringify(value));
        return value;
    } catch {
        // Intentionally left blank
    }
};

const removeItem = (key: string, prefix = STORAGE_PREFIX) => {
    try {
        localStorage.removeItem(`${prefix}${key}`);
    } catch {
        // Intentionally left blank
    }
};

const load = (key: string, prefix: string = STORAGE_PREFIX): string | undefined => {
    try {
        const item = localStorage.getItem(`${prefix}${key}`);
        return item && JSON.parse(item);
    } catch {
        // Intentionally left blank
    }
};

export const storage = { save, load, removeItem };
